import React from 'react';
import { ArrowRight } from 'lucide-react';
import { colors, fonts } from '../tokens';

/**
 * OptionCard – Alternative-Möglichkeit auf Page 4 (z. B. Direktkauf, Beratung).
 * Akzentfarbe steuert die linke Border.
 */
export const OptionCard = ({ title, description, hint, accentColor = colors.orange }) => (
  <div
    style={{
      padding: '12px 14px',
      background: colors.bgSoft,
      borderRadius: '9px',
      border: `1px solid ${colors.border}`,
      borderLeft: `3px solid ${accentColor}`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      boxSizing: 'border-box',
    }}
  >
    <div>
      <h3 style={{ fontFamily: fonts.display, fontSize: '11px', fontWeight: 700, color: colors.navy, marginBottom: '5px' }}>{title}</h3>
      <p className="proposal-body" style={{ fontSize: '9.5px' }}>{description}</p>
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '6px' }}>
      <ArrowRight size={10} color={accentColor} />
      <span style={{ fontFamily: fonts.body, fontSize: '8.5px', fontWeight: 600, color: accentColor }}>{hint}</span>
    </div>
  </div>
);
